module.exports = __webpack_public_path__ + "img/xs.5f88dd28.png";